import { render, staticRenderFns } from "./StatisticField.vue?vue&type=template&id=2d0cd6f4&scoped=true"
import script from "./StatisticField.vue?vue&type=script&lang=js"
export * from "./StatisticField.vue?vue&type=script&lang=js"
import style0 from "./StatisticField.vue?vue&type=style&index=0&id=2d0cd6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0cd6f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VSimpleTable})
